var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip364_2071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip364_2071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1611 21.3567L32.5869 13.1436",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5869 35.6057L16.1611 27.3926",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 24.375C16.875 20.647 13.853 17.625 10.125 17.625C6.39697 17.625 3.375 20.647 3.375 24.375C3.375 28.1028 6.39697 31.125 10.125 31.125C13.853 31.125 16.875 28.1028 16.875 24.375Z",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.375 10.125C45.375 6.39697 42.353 3.375 38.625 3.375C34.897 3.375 31.875 6.39697 31.875 10.125C31.875 13.853 34.897 16.875 38.625 16.875C42.353 16.875 45.375 13.853 45.375 10.125Z",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.375 38.625C45.375 34.897 42.353 31.875 38.625 31.875C34.897 31.875 31.875 34.897 31.875 38.625C31.875 42.3528 34.897 45.375 38.625 45.375C42.353 45.375 45.375 42.3528 45.375 38.625Z",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkConnection);
export default __webpack_public_path__ + "static/media/network-connection.bf89f6cbfb63f6df94b2fe177acb63c4.svg";
export { ForwardRef as ReactComponent };